/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_Sign_OutInputs */



/**
* | output |
* | --- |
* | "Sign out" |
*
* @param {Layout_Header_Sign_OutInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_sign_out = /** @type {((inputs?: Layout_Header_Sign_OutInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Sign_OutInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abmelden")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Se déconnecter")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("退出登录")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("登出")
	if (locale === "ko") return /** @type {LocalizedString} */ ("로그아웃")
	return /** @type {LocalizedString} */ ("Sign out")
});